import { useState } from "react";
import PageFadeIn from "../components/shared/PageFadeIn";
import { data } from "../utils/data";
import { AnimatePresence, motion } from "framer-motion";

const Crew = () => {
	const crew = data.crew;
	const [selected, setSelected] = useState(0);

	return (
		<PageFadeIn>
			<div className='absolute top-0 left-0 w-full min-h-full pt-[88px] md:pt-[136px] xl:pt-[212px] px-6 md:px-[40px] xl:px-[165px] bg-crew_mobile md:bg-crew_tablet xl:bg-crew_desktop bg-cover xl:flex xl:flex-col xl:justify-between'>
				{/* 02 meet your crew */}
				<div className='xl:w-1/2 mb-8 md:mb-[64px] xl:mb-0 flex items-center justify-center md:justify-start gap-[18px]'>
					<p className='font-barlow font-bold md:text-20 xl:text-[28px] leading-19 md:leading-[24px] xl:leading-[34px] tracking-27 md:tracking-[3.37px] xl:tracking-[4.725px] text-white opacity-25'>
						02
					</p>
					<p className='font-barlow md:text-20 xl:text-[28px] leading-19 md:leading-[24px] xl:leading-[34px] tracking-27 md:tracking-[3.37px] xl:tracking-[4.725px] text-white uppercase'>
						Meet your crew
					</p>
				</div>
				{/* all content except meet your crew */}
				<div className='xl:h-full flex flex-col md:flex-col-reverse xl:flex-row-reverse'>
					{/* mobile image, then picker, then info */}
					{/* image only */}
					<AnimatePresence exitBeforeEnter>
						<motion.div
							className={`w-full h-225 md:h-[532px] xl:h-[688px] mx-auto ${crew[selected].photo} bg-contain bg-no-repeat bg-bottom`}
							key={selected}
							animate={{ opacity: 1 }}
							initial={{ opacity: 0 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.4 }}
						/>
					</AnimatePresence>
					{/* divider below image, mobile only */}
					<div className='w-full h-px md:hidden bg-border_grey opacity-50' />
					{/* picker and info are flex-col and in this order for mobile, flex-row-reverse or flex-col-reverse for tablet and desktop */}
					{/* picker and info */}
					<div className='w-full xl:w-[614px] mx-auto flex flex-col md:flex-col-reverse items-center xl:items-start xl:justify-between'>
						{/* picker */}
						<motion.div className='w-88 xl:w-[132px] h-10 xl:h-[15px] my-8 md:my-10 xl:mt-[120px] xl:mb-[94px] flex justify-between'>
							{crew.map((member, index) => (
								<div key={member.name} className='relative flex'>
									<div
										className='w-10 h-10 xl:w-[15px] xl:h-[15px] bg-border-grey border border-white rounded-full'
										onClick={() => setSelected(index)}
									/>
									{index === selected && (
										<motion.div
											className='absolute w-10 h-10 xl:w-[15px] xl:h-[15px] bg-white rounded-full'
											layoutId='selected_crew'
										/>
									)}
								</div>
							))}
						</motion.div>
						{/* info */}
						<AnimatePresence exitBeforeEnter>
							<motion.div
								className='md:w-[458px] xl:w-[614px] xl:mt-[154px] flex flex-col items-center xl:items-start'
								key={selected}
								animate={{ opacity: 1 }}
								initial={{ opacity: 0 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 0.4 }}
							>
								<p className='font-bellefair text-16 md:text-24 xl:text-32 leading-[18px] md:leading-[28px] xl:leading-[37px] text-white uppercase opacity-50'>
									{crew[selected].role}
								</p>
								<p className='mt-2 mb-4 md:mt-1 md:mb-4 xl:mt-[15px] xl:mb-[27px] font-bellefair text-24 md:text-[40px] xl:text-[56px] leading-[28px] md:leading-[46px] xl:leading-[64px] text-white uppercase'>
									{crew[selected].name}
								</p>
								<p className='xl:w-[444px] font-barlow text-[15px] md:text-16 xl:text-[18px] leading-[25px] md:leading-[28px] xl:leading-[32px] tracking-[1.5px] text-lavender text-center xl:text-left'>
									{crew[selected].bio}
								</p>
							</motion.div>
						</AnimatePresence>
					</div>
				</div>
			</div>
		</PageFadeIn>
	);
};

export default Crew;
